import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const SearchHint = ({ quickSearchMode }) => {
  const styles = useStyles();
  return (
    <>
      <div className={styles.emptySearchTextWrapper}>
        <CustomTypography
          variant={TYPOGRAPHY_VARIANT.paragraph14}
          align="center"
        >
          Search for a webpage, file,
          <br />
          messaging bank asset, or image
        </CustomTypography>
      </div>
      {!quickSearchMode && (
        <CustomTypography
          variant={TYPOGRAPHY_VARIANT.regular14}
          align="center"
          className={styles.hint}
        >
          Hint: Type @ in the prompt area for quick access
        </CustomTypography>
      )}
    </>
  );
};

SearchHint.propTypes = {
  quickSearchMode: PropTypes.bool,
};

SearchHint.defaultProps = {
  quickSearchMode: false,
};
